let operators = {
   EQUAL:   "equals",
   LIKE:    "like",
   LESS:    "lt",
   GREATER: "gt",
}

function Filter() {
   this._operator = operators.EQUAL
   this._field    = "default"
   this._value    = ""
   this._extra    = true
   this._cats     = false
   return this
}

Filter.prototype.operator = function (operator) {
   this._operator = operator
   return this
}

Filter.prototype.searchField = function (extra = true) {
   this._extra = extra
   return this
}

Filter.prototype.category = function () {
   this._cats = true
   return this
}

Filter.prototype.field = function (field) {
   this._field = field
   return this
}

Filter.prototype.query = function (value) {
   this._value = value
   let filter  = ""
   if (this._cats) {
      if(!Array.isArray(value)){
         value = [value]
      }
      filter = {cats: value}
   }
   else {
      filter = {
         extra: this._extra,
         op:    this._operator,
         value: this._value,
         field: this._field
      }
   }

   // let encoded = encodeURIComponent(filterText)
   return filter
}

// let colorFilter = new Filter()
//    .operator(operators.LIKE)
//    .field("color")
//
// console.log("cf1", colorFilter.query("red"))
// console.log("cf1", colorFilter.query("blze"))
// console.log("cf1", colorFilter.query("white"))
// console.log("cf1", colorFilter.query("#efefef"))
// console.log("cf1", colorFilter.query("green"))


export default Filter



// WEBPACK FOOTER //
// ./src/sdk/filter/Filter.js